import { SuperAdminNavigationGroup } from './sidebar-admin.model'

/**
 * Super Admin navigation. Every entry points at a route that exists under
 * /admin (see pages/admin/admin.routes.ts) - never add placeholders here.
 */
export const superAdminNavigationGroups: SuperAdminNavigationGroup[] = [
    {
        label: 'SUPER ADMIN',
        items: [
            {
                label: 'Dashboard',
                icon: 'lucideLayoutDashboard',
                routerLink: '/admin',
            },
            {
                label: 'Shops',
                icon: 'lucideStore',
                routerLink: '/admin/shops',
            },
            {
                label: 'Users',
                icon: 'lucideUsers',
                routerLink: '/admin/users',
            },
            {
                label: 'Admins',
                icon: 'lucideShieldCheck',
                routerLink: '/admin/admins',
            },
            {
                label: 'Plans',
                icon: 'lucideCreditCard',
                routerLink: '/admin/plans',
            },
        ],
    },
]
